(function () {
  'use strict';

  // Measure container, cap swatches to one row, inject +N chip as last slot.
  function initSiblingsCap() {
    var wrap = document.getElementById('tds-pv-siblings-wrap');
    if (!wrap) return;
    var swatches = Array.from(wrap.querySelectorAll('.tds-pv-swatch'));
    if (swatches.length === 0) return;

    // User previously expanded — stay expanded across pattern navigations
    if (sessionStorage.getItem('tds-pvs-expanded')) return;

    var swatchSize = 44; // px (matches CSS width)
    var gap = 8;         // px (matches CSS gap)
    var perRow = Math.floor((wrap.offsetWidth + gap) / (swatchSize + gap));

    if (swatches.length <= perRow) return; // all fit, nothing to do

    var cap = perRow - 1; // reserve last slot for chip

    swatches.forEach(function (sw, i) {
      if (i >= cap) sw.classList.add('tds-pv-swatch--hidden');
    });

    var hiddenCount = swatches.length - cap;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tds-pv-swatch tds-pv-swatch--more';
    btn.id = 'tds-pv-siblings-more';
    btn.setAttribute('aria-label', 'Show ' + hiddenCount + ' more patterns');
    btn.textContent = '+' + hiddenCount;
    wrap.appendChild(btn);

    btn.addEventListener('click', function () {
      sessionStorage.setItem('tds-pvs-expanded', '1');
      wrap.querySelectorAll('.tds-pv-swatch--hidden').forEach(function (sw) {
        sw.classList.remove('tds-pv-swatch--hidden');
      });
      btn.remove();
    });
  }

  // Colourway dot: update name label and navigate when handle differs from current product.
  function bindColourwayDots() {
    var row = document.getElementById('tds-pv-cway-row');
    if (!row) return;
    var nameEl = document.getElementById('tds-pv-cway-name');
    row.addEventListener('click', function (e) {
      var dot = e.target.closest('.tds-pv-cway');
      if (!dot) return;
      var handle = dot.dataset.cwayHandle;
      var name = dot.dataset.cwayName;
      if (!handle) return;

      row.querySelectorAll('.tds-pv-cway').forEach(function (d) {
        d.classList.remove('tds-pv-cway--active');
        d.setAttribute('aria-pressed', 'false');
      });
      dot.classList.add('tds-pv-cway--active');
      dot.setAttribute('aria-pressed', 'true');
      if (nameEl) nameEl.textContent = name;

      var stickySubEl = document.getElementById('tds-pv-sticky-sub');
      if (stickySubEl) stickySubEl.textContent = name ? ' · ' + name : '';

      var currentHandle = window.tessaraProduct ? window.tessaraProduct.handle : null;
      if (handle !== currentHandle) {
        window.location.href = '/products/' + handle;
      }
    });
  }

  // Mirror size chip price into the sticky bar price slot.
  function bindStickyPriceSync() {
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('.tds-size-chip');
      if (!chip || !chip.dataset.price) return;
      var el = document.getElementById('tds-pv-sticky-price');
      if (el) el.textContent = chip.dataset.price;
    });
  }

  // Show sticky bar when the ATC form scrolls fully out of the viewport.
  function initStickyBar() {
    var bar = document.getElementById('tds-pv-sticky');
    var anchor = document.getElementById('tds-atc-form');
    if (!bar || !anchor || !window.IntersectionObserver) return;

    var obs = new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting;
      bar.classList.toggle('tds-pv-sticky--visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }, { threshold: 0 });
    obs.observe(anchor);
  }

  function init() {
    initSiblingsCap();
    bindColourwayDots();
    bindStickyPriceSync();
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
